import { useSnapshot } from "valtio";
import { state } from "../store";
import "./SeatsColorsPanel.css";

export default function SeatsColorsPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "seats-colors";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define seats-specific color presets (same as accent colors)
  const seatsColors = [
    // Whites and Light Colors

    // Blues
    {
      name: "Electric Blue",
      color: "#3b3e4a",
    },
    {
      name: "Ocean Blue",
      color: "#0d7c9f",
    },
    {
      name: "Deep Blue",
      color: "#335688",
    },

    // Purples
    {
      name: "Deep Purple",
      color: "#882f54",
    },
    {
      name: "Light Blue",
      color: "#976544",
    },

    // Greens
    {
      name: "Racing Green",
      color: "#117d60",
    },

    // Oranges and Reds
    {
      name: "Sunset Orange",
      color: "#ba3009",
    },

    // Dark Colors
    {
      name: "Carbon Black",
      color: "#bdc1c7",
    },
  ];

  const applySeatsColor = (colorPreset) => {
    // Store seats-specific color for Cusion_Blue material ONLY
    state.seatsColor = colorPreset.color;

    // Do NOT update waterColor - keep seats color independent
    // Do NOT close panel automatically - let user close manually
  };

  // Helper function to adjust brightness of a color
  const adjustBrightness = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return "#" + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title">SEATS COLORS</h2>
          <div className="seats-colors-wrapper">
            <div className="seats-colors-panel">
              <div className="seats-colors-grid">
                {seatsColors.map((colorPreset, index) => (
                  <div key={index} className="seats-color-item" onClick={() => applySeatsColor(colorPreset)}>
                    <div
                      className="seats-color-swatch"
                      style={{
                        "--color": colorPreset.color,
                        "--color-light": adjustBrightness(colorPreset.color, 30),
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button className="close-button-seats-colors" onClick={handleClose}>
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
